<template>
  <div
    v-if="oidcIsAuthenticated"
  >
  <div class="input_container">
    <table style="width:100%">
      <tr>
        <th>Username</th>
        <td class= "content" v-html="userName"></td>
      </tr>
      <tr>
        <th>First Name</th>
        <td class= "content" v-html="firstName"></td>
      </tr>
      <tr>
        <th>Last Name</th>
        <td class= "content" v-html="familyName"></td>
      </tr>
      <tr>
        <th>Email</th>
        <td class= "content" v-html="email"></td>
      </tr>
      <!-- <tr>
        <th>Access Token</th>
        <td class= "token" v-html="accessToken"></td>
      </tr> -->
    </table>
    <h4>Deleting your account?</h4>
    <p>Please contact <a v-bind:href="mailtoHref">our support team</a>, using the email address: {{ email }}, to request an account deletion for this account.</p>
  </div>
  </div>
  <p v-else-if="oidcAuthenticationIsChecked">You are signed out, redirecting...</p>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SignedInUser',
  computed: {
    ...mapGetters('oidcStore', [
      'oidcIsAuthenticated',
      'oidcAuthenticationIsChecked',
      'oidcUser',
      'oidcIdToken',
      'oidcIdTokenExp'
    ]),
    mailtoHref: function () {
      return 'mailto:Samaggi%20Support%20<info@samaggisamagom.com>?subject=Account%20Deletion%20Request:%20' + this.userName
    },
    userName: function () {
      return this.oidcUser['cognito:username']
    },
    firstName: function () {
      return this.oidcUser['given_name']
    },
    familyName: function () {
      return this.oidcUser['family_name']
    },
    email: function () {
      return this.oidcUser['email']
    }
    // emailverified: function () {
    //   return this.oidcUser['email_verified']
    // },
    // accessToken: function () {
    //   return this.oidcUser['sub']
    // }
  }
}
</script>

<style>
table {
  padding: 0;
}
th{
  text-align: left;
  /* display: flex; */
  /* padding-top: 2%; */
}
.content{
  font-family: monospace;
  font-size: 100%;
  color:black;
  display:inline;
  text-align: right;
  /* padding-bottom: 100%; */
}
.token{
  font-size: 10pt
}

</style>
